






















































import { Component, Vue } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Tabs } from '@/constants/appSettings'
import { createDefaultAppSettings } from '@/utils/appSettings'

@Component
export default class TabSettingForm extends Vue {
  readonly tabConstants = Tabs

  $store!: ExStore
  inputTabs = [...this.tabs]
  updatePending = false

  get tabs() {
    return this.$store.getters['appSettings/tabs']
  }

  get displayTabs() {
    return this.inputTabs.sort((tab1, tab2) => tab1.order - tab2.order)
  }

  handleClickDown(index: number) {
    if (index === this.inputTabs.length - 1) {
      return
    }

    const o1 = this.inputTabs[index].order
    const o2 = this.inputTabs[index + 1].order

    this.$set(this.inputTabs[index], 'order', o2)
    this.$set(this.inputTabs[index + 1], 'order', o1)
  }

  handleClickUp(index: number) {
    if (index === 0) {
      return
    }

    const o1 = this.inputTabs[index - 1].order
    const o2 = this.inputTabs[index].order

    this.$set(this.inputTabs[index - 1], 'order', o2)
    this.$set(this.inputTabs[index], 'order', o1)
  }

  handleClickReset() {
    this.inputTabs = createDefaultAppSettings().tabs
  }

  async handleClickSave() {
    try {
      if (this.updatePending) {
        return
      }

      this.updatePending = true
      const tabs = this.inputTabs
      await this.$store.dispatch('appSettings/update', { tabs })
      this.inputTabs = [...this.$store.getters['appSettings/tabs']]
    } catch (error) {
      //
    } finally {
      this.updatePending = false
    }
  }
}
